import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=27142913&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=27142913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27142913",
  null
  
)

export default component.exports